import { LogLevel } from "@azure/msal-browser";
import { getRedirectUri } from "../utils/api-config";

export const b2cPolicies = {
  names: { signIn: process.env.REACT_APP_USER_FLOW },
  authorities: {
    signIn: {
      authority:
        process.env.REACT_APP_AUTHORITY_URL,
    },
  },
  authorityDomain: process.env.REACT_APP_AUTHORITY_DOMAIN,
};

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    authority: b2cPolicies.authorities.signIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: true,
    state: "test",
  },
  cache: { cacheLocation: "localStorage", storeAuthStateInCookie: false },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error("[MSAL]", message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn("[MSAL]", message);
            return;
          default:
            return null;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access"],
  state: "page_url",
  redirectStartPage: getRedirectUri()
};

export const graphConfig = {
  graphMeEndpoint: process.env.REACT_APP_GRAPH_URL,
};
